import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const DriverBirthdaySettingsPage = loadable(
  async () => import("~/features/driver-birthdays/pages/DriverBirthdaySettingsPage"),
  { fallback: <></> },
)

export const driverBirthdayRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.birthdaySettings,
    element: <DriverBirthdaySettingsPage />,
  },
]
